import { useParams } from "react-router-dom";
import styles from "../../Styles/Generalinfo.module.scss";

function Generalinfo() {
  const insurance = {
    href: "https://www.travelguard.com/",
    target: "_blank"
  };
  const ScotlandPermit = {
    href: "https://www.gov.uk/eta",
    target: "_blank"
  };

  const params = useParams();

  let dates = "";
  let cost = [];
  let groupSize = "";
  let servicesIncluded = [];
  let servicesExcluded = [];

  const costMay = [
    "$2,500 plus airfare and food after breakfast (double occupancy)",
    "Tourist purchases their own airfare.",
    "Single supplement is $890"
  ];

  const servicesIncludedTrip = [
    "Transportation in country",
    "Accommodation for eight nights",
    "Breakfast included except for two nights while staying in Fort Augusta  ",
    "Entry costs to all sites and activities listed in the itinerary"
  ];
  const servicesExcludedTrip = [
    "Airfare",
    "Lunches and dinners",
    "Medical, traveler’s or personal insurance.",
    "Personal expenses",
    "Passport and an ETA for UK entry (see Travel Documents below to know how to secure this.)"
  ];

  switch (params.trip) {
    case "May_20-29":
      dates = "May 20 - 29, 2026";
      cost = costMay;
      groupSize = "12 - 16";
      servicesIncluded = servicesIncludedTrip;
      servicesExcluded = servicesExcludedTrip;
      break;

    case "trip":
      dates = "TBA";
      cost = ["TBA"];
      groupSize = "12 - 16";
      servicesIncluded = servicesIncludedTrip;
      servicesExcluded = servicesExcludedTrip;

      break;
  }

  return (
    <div className="pageContainer">
      <div className="title">General Information</div>

      <div>
        <div className={styles.paragraphTitle}>TRIP DATES</div>
        <p className="text">{dates}</p>
      </div>

      <div>
        <div className={styles.paragraphTitle}>GROUP SIZE</div>
        <p className="text">{groupSize}</p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>COST</div>
        {cost.map((par) => (
          <p className={styles.list}>{par}</p>
        ))}
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesIncluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES NOT INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesExcluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DOCUMENTS</div>
        <p className="text">
          You will need a USA passport. Make sure your passport is valid and
          does not expire at least six months AFTER your re-entry date to the
          United States.
        </p>
        <p className="text">
          You will also need an ETA entry permit fee (to be applied for by
          travelers). For detailed information and to apply, please visit the UK
          Entry Permit System{" "}
          <a {...ScotlandPermit} rel="norferrer" className={styles.link}>
            gov.uk/eta
          </a>{" "}
          The ETA costs approximately $22. Please acquire this online at least
          30 days before departure.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>INSURANCE</div>
        <p className="text">
          [OPTIONAL] If you wish to purchase insurance for your trip, we
          recommend you use Travel Guard. There are many travel insurance
          companies out there, however, and one of them may prove to be a better
          option for you. You can visit
          <a {...insurance} rel="norferrer" className={styles.link}>
            TravelGuard.com
          </a>
          or call them at <span className={styles.highlight}>800-826-5248</span>
          . They have multiple options for insuring anything from the flight
          itself to the full cost of the trip. Most plans cover sickness,
          injury, or death of a family member.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          CANCELLATION AND REFUND POLICY
        </div>
        <p className="text">
          If you need to cancel your tour, you can do it, provided it is 120
          days before the tour date. After this, the trip is generally
          non-refundable due to contracts with hotels, guides, and
          transportation services.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>HOW TO SIGN UP FOR THE TRIP</div>
        <p className="text">
          Contact Dan Glick at{" "}
          <span className={styles.highlight}> danglick62@gmail.com</span> and
          provide your full passport name (exactly as it appears on your
          passport), date of birth, phone number, email address, and physical
          address. Then send in your deposit.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DEPOSIT</div>
        <p className="text">
          A $500 deposit is required to reserve your seat on this trip. Only a
          check is accepted as a form of payment. Checks should be made to{" "}
          <span style={{ textDecoration: "underline" }}>
            Tribe of Dan Tours
          </span>{" "}
          and mailed to Dan Glick, 9850 Cedar Cove, Alexandria, KY 41001.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PAYMENT POLICY</div>
        <p className="text">
          <span>The final payment will be due 120 days before departure.</span>{" "}
          Only a check is accepted as a form of payment. Checks should be made
          to Tribe of Dan Tours and mailed to Dan Glick, 9850 Cedar Cove,
          Alexandria, KY 41001.
        </p>
      </div>

      <div>
        <div className={styles.paragraphTitle}>PRE-TRIP MATERIALS</div>
        <p className="text">
          Tribe of Dan Tours provides the following documents: 1) An itinerary
          2) A list of YouTube videos that one can watch about the country and
          history of Scotland. This is very helpful information prior to the
          trip, and Dan strongly encourages all tourists to take advantage of
          this and watch them in the months prior to the trip. 3) A suggestive
          packing list. 4) A prayer guide. 5) Some travel advice. 6) A gallery
          of photos.
        </p>
      </div>

      <div>
        <div className={styles.paragraphTitle}>PHYSICAL REQUIREMENTS</div>
        <p className="text">
          There is substantial walking on this trip. It is recommended that you
          get a good amount of walking exercise in the weeks preceding the trip.
          There are no special vaccines required for entry into Scotland.
        </p>
      </div>
    </div>
  );
}

export default Generalinfo;
